<template>
  <v-card
    class="mx-auto"
    elevation="0"
    width="360"
  >
    <div class=" d-flex justify-between">
      <v-card-title class="flex-grow-1 flex-column align-start">
        <div class="text-body-1">Views from my farm built on Triyangle. If your ever in Uganda, come and check it out at…</div>
        <div class="text-body-2 font-weight-thin">2 mins ago</div>
      </v-card-title>
      <v-img
        src="https://africabusiness.com/wp-content/uploads/2023/06/Wingcopter198_SiemensHealthineers_low-res-Africa-2048x1317.jpg"
        style="flex-basis: 125px"
        class="flex-grow-0"
      ></v-img>
    </div>
    <v-divider></v-divider>
    <v-card-actions class="pr-3">
        <v-bottom-sheet width="1200px" v-model="sheet">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    elevation="0"
                    v-bind="attrs"
                    v-model="sheet"
                    v-on="on"
                    color="transparent" 
                    density="compact"
                    padding="0px"
                    box-shadow="0px"
                >
                <v-list-item-avatar>
                <v-img
                    src="https://cdn.vuetifyjs.com/images/lists/3.jpg"
                ></v-img>
                </v-list-item-avatar>
                </v-btn>
            </template>
            <profilePage/>
        </v-bottom-sheet>
        <v-row align="center" justify="end" class="pr-2">
            <v-icon class="mr-1" color="blue darken-3">
                mdi-eye
            </v-icon>
            <span class="subheading mr-2" >13k</span>
            <span class="mr-2">·</span>
            <v-icon 
                class="mr-1" 
                color="blue darken-3"
                >
                mdi-comment-multiple
            </v-icon>
            <span class="subheading mr-2">2k</span>
            <span class="mr-1">·</span>
            <v-btn
                @click="disabled = !disabled"
                elevation="0"
                color="transparent"
                fab
                small
            >
                <v-icon color="red">mdi-heart</v-icon>
            </v-btn>
            <span class="subheading mr-2">9k</span>
            <span>·</span> 
            <v-menu
                v-model="fab"
                :left="left"
                :top="top"
                :open-on-hover="hover"
                :transition="transition"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-model="fab"
                        color="transparent"
                        v-bind="attrs"
                        v-on="on"
                        @click="fav = !fav"
                        elevation="0"
                        dark
                        small
                     >
                     <v-icon v-if="fab" color="blue darken-4">
                        mdi-close
                      </v-icon>
                      <v-icon v-else color="blue darken-4">
                        mdi-share-variant
                      </v-icon>
                    </v-btn>
                </template>
                <v-btn fab dark small color="primary">
                    <v-icon>mdi-send</v-icon>
                </v-btn>
                <v-btn fab dark small color="green">
                    <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn fab dark small color="primary">
                    <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn fab dark small color="primary">
                    <v-icon>mdi-link-variant</v-icon>
                </v-btn>
            </v-menu>
            <span class="subheading">8k</span>
        </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import profilePage from './profilePage'
  export default {
      data: () => ({ 
        bottom: true,
        showProfilePage: false,
        fab: false,
        transition: 'slide-y-transition',
    }),
    components: {
        profilePage
    },
    methods: {
        toggleProfilePage() {
            this.showProfilePage = !this.showProfilePage;
        },
    }
  }
</script>